import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    fullImage:{
        maxWidth:"100%",
        textAlign:'left',
        [theme.breakpoints.down('sm')]: {
            width: '80%',
            margin:'auto',
            marginTop:50,
        }
    }
}))

export default React.memo(({src}:any)=>{
    const classes = useStyles({});
    return (
        <img src={src} className={classes.fullImage} alt="full-image"/>
    )
})


// WEBPACK FOOTER //
// ./src/pages/home/components/FullImage.tsx